import moment from 'moment'
import _ from 'lodash'

export default landingOffrePrintemps2018Ctrl

/** @ngInject */
function landingOffrePrintemps2018Ctrl($state, $scope, $interval, ContactTelephone, gaEventsService) {
    $scope.contactTelephone = ContactTelephone
    $scope.gaEventsService = gaEventsService
    $scope.params = $state.params
    $scope.partner = {
        selectra: ['PRINTEMPS_2018_SELECTRA_MVSA', 'PRINTEMPS_2018_SELECTRA_SOS_SENIORS'].indexOf($state.params.id_ref_promo) === -1,
        mvsa: $state.params.id_ref_promo === 'PRINTEMPS_2018_SELECTRA_MVSA',
        sosSeniors: $state.params.id_ref_promo === 'PRINTEMPS_2018_SELECTRA_SOS_SENIORS',
    }
    $scope.partnerOfferEnd = moment('2018-07-10')
    $scope.displayCountdown = 0

    $scope.countdownDetail = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    }

    $interval(() => {
        const countdown = moment.duration($scope.partnerOfferEnd.diff())
        $scope.countdownDetail = {
            days: Math.trunc(countdown.asDays()),
            hours: _.padStart(countdown.hours(), 2, '0'),
            minutes: _.padStart(countdown.minutes(), 2, '0'),
            seconds: _.padStart(countdown.seconds(), 2, '0'),
        }
    }, 1000, 0)
}



// WEBPACK FOOTER //
// ./src/states/subscriptionLanding/landingOffrePrintemps2018.js